// Utility functions for API payloads and responses
import { formatDate } from "components/registration/utilities";

export function buildEligibilityPayload(SPONSOR_ID, formData) {
    return {
        sponsorSymbol: SPONSOR_ID,
        firstName: formData.eligibility.firstName?.trim(),
        lastName: formData.eligibility.lastName?.trim(),
        dateOfBirth: formatDate(formData.eligibility.dateOfBirth),
        zip: formData.moreInfo.zipCode?.trim(),
    };
}

export function buildProgramPayload(formData) {
    return {
        dateOfBirth: formatDate(formData.eligibility.dateOfBirth),
        treatAnswers: formData.treat.treatOptions,
        preventAnswers: formData.prevent.preventOptions,
    };
}

export function buildAccountPayload(SPONSOR_ID, formData) {
    return {
        sponsorSymbol: SPONSOR_ID,
        firstName: formData.eligibility.firstName?.trim(),
        lastName: formData.eligibility.lastName?.trim(),
        email: formData.createAccount.email?.trim(),
        password: formData.createAccount.password,
        dateOfBirth: formatDate(formData.eligibility.dateOfBirth),
        phoneNumber: formData.createAccount.phone?.trim(),
        programId: formData.internalFormData.programId,
        eligibleId: formData.internalFormData.eligibleId,
        consentTosPp: formData.createAccount.terms,
        consentMarketing: formData.createAccount.consent,
        statementsOpt: {
            treatAnswers: formData.treat.treatOptions,
            preventAnswers: formData.prevent.preventOptions,
        },
    };
}

export function buildShippingAddress(formData) {
    return {
        name: `${formData.shipping.firstName?.trim()} ${formData.shipping.lastName?.trim()}`,
        primaryLine: formData.shipping.address1?.trim(),
        secondaryLine: formData.shipping.address2?.trim(),
        city: formData.shipping.city?.trim(),
        state: formData.shipping.state?.value,
        zipCode: formData.shipping.postalCode?.trim(),
        verification: "ok",
    };
}
